import React from 'react';
import { RegionMappings } from '../components/RegionMapping';
import { WorldMappings } from '../components/WorldMapping';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

export const RegionTable  = () => {
    return (
        <RegionMappings />
    );
};